module.exports = __webpack_public_path__ + "img/icon-like.a8cd566a.png";